import { ModalProps as AntdModalProps } from 'antd';

export type ModalProps = AntdModalProps & {};

export type DefaultModalProps = {};

export const defaultProps: DefaultModalProps = {};
